import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import LoadingSpinner from '../../components/LoadingSpinner';
import axios from 'axios';
import { ApiConnectionString } from '../../constants/ApiConntection';
import { useAuthContext } from '../../hooks/useAuthContext';
import BookingOrClassCancellation from './BookingOrClassCancellation';
import YouHaveUnsubscribed from './YouHaveUnsubscribed';
import YourRecurringPaymentHasBeenUnsuccessful  from './YourRecurringPaymentHasBeenUnsuccessful'
import ClassBookingConfirmed from './ClassBookingConfirmed';
import BookingCancellationRequested from './BookingCancellationRequested';
import UserBoughtTokens from './UserBoughtTokens';
import UserSubscribedToYourClub from './UserSubscribedToYourClub';
import PaymentForSubscriptionUnsuccessful from './PaymentForSubscriptionUnsuccessful';
import UserUnsubscribedFromYourClub from './UserUnsubscribedFromYourClub';
import PaymentResolved from './PaymentResolved';
import PremiumSubscriptionFailedPayment from './PremiumSubscriptionFailedPayment';
import PremiumClubMembershipCanceled from './PremiumClubMembershipCanceled';
import PaymentAndBookingConfirmation from './PaymentAndBookingConfirmation';
import "./OneNotification.css"
import YouHaveBeenBookedIntoAClass from './YouHaveBeenBookedIntoAClass';
import Refunded from './Refunded';


export default function OneNotification() {
    const {id} = useParams();
    const [notification,setNotification] = useState(null)
    const [isLoading,setIsLoading] = useState(true)
    const {user} = useAuthContext();
    


    const fetchData = async () => {
        try {
            setIsLoading(true);
            const notificationResponse = await axios.get(`${ApiConnectionString}/api/notification/${id}`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
    
            if (notificationResponse.status === 200) {
                setNotification(notificationResponse.data);
            }
        } catch (error) {
            console.error('Error fetching notification:', error);
            // Handle the error as needed, for example, setting an error state
        } finally {
            setIsLoading(false);  // This ensures loading stops whether there's an error or not
        }
    };
    

    const renderComponent = () => {
        if(notification){

         
            switch (notification.type) {
                case 1:
                  return <BookingOrClassCancellation notification={notification}/>;
                case 2:
                  return <YouHaveUnsubscribed notification={notification}/>;
                case 3:
                  return <YourRecurringPaymentHasBeenUnsuccessful notification={notification}/>;
                case 4:
                  return <ClassBookingConfirmed notification={notification}/>;
                case 5:
                  return <BookingCancellationRequested notification={notification}/>;
                case 6:
                  return <UserBoughtTokens notification={notification}/>;
                case 7:
                  return <UserSubscribedToYourClub notification={notification}/>;
                case 8:
                  return <PaymentForSubscriptionUnsuccessful notification={notification}/>;
                  case 9:
                    return <UserUnsubscribedFromYourClub notification={notification}/>;
                  case 11:
                    return <PaymentResolved notification={notification}/>;
                  case 12:
                    return <PremiumSubscriptionFailedPayment notification={notification}/>;
                  case 13:
                    return <PremiumClubMembershipCanceled notification={notification}/>;
                  case 14:
                    return <PaymentAndBookingConfirmation notification={notification}/>;
                    case 15:
                    return <Navigate to={"/HelpAndSupport"} />
                    case 16:
                      return <YouHaveBeenBookedIntoAClass notification={notification}/>;
                      case 17:
                        return <Refunded notification={notification}/>;
                default:
                  return null;
              }
        }
       
      };

    useEffect(() => {
fetchData()
    },[id,user])

    if(isLoading){
        return (
            <div><LoadingSpinner/></div>
          )
    }else{
        if(notification != null){
            return (
                <div>
                    {renderComponent()}
                </div>
              )
        }else{
            return (
                <div>
                    <p>Notification not Found</p>
                </div>
              )
        }
    }
    

  
 
}
